export const environment = {
  production: true,
  apiUrl: "https://gastonapi.educoitalia.it/api/",
  ipServiceUrl : 'https://api.ipify.org/?format=json',
  blobBasepath : "https://gastonapp.blob.core.windows.net/master/",
  paymentBasePath: "https://checkout.educoitalia.it/checkout/buy/",
};
